import { render, staticRenderFns } from "./assessList.vue?vue&type=template&id=868bc3c2&scoped=true"
import script from "./assessList.vue?vue&type=script&lang=js"
export * from "./assessList.vue?vue&type=script&lang=js"
import style0 from "./assessList.vue?vue&type=style&index=0&id=868bc3c2&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868bc3c2",
  null
  
)

export default component.exports